<template>
  <el-dialog
    :title="!!rowData.id ? '编辑线索池' : '新增线索池'"
    :visible.sync="dialogVisible"
    width="40%"
    class="addCluePoolDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addCluePoolForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="线索池名称" prop="poolName">
            <el-input v-model="formData.poolName" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="线索池管理员" prop="poolAdmin">
            <el-select
              class="special"
              v-model="formData.poolAdmin"
              filterable
              remote
              reserve-keyword
              clearable
              multiple
              placeholder="请输入关键词"
              :remote-method="getPoolAdminList"
              :loading="poolAdminLoading"
            >
              <el-option v-for="item in poolAdminList" :key="item.userId" :label="item.userName" :value="item.customField" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="线索池所属部门" prop="deptCode">
            <el-select
              v-model="formData.deptCode"
              filterable
              remote
              clearable
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="getDeptList"
              :loading="deptLoading"
            >
              <el-option v-for="item in deptList" :key="item.userId" :label="item.deptName" :value="item.deptCode" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="分发规则">
            <el-radio-group v-model="formData.distributeType">
              <el-radio label="手动领取（成员可见）">手动领取（成员可见）</el-radio>
              <el-radio label="领导分配（成员不可见）">领导分配（成员不可见）</el-radio>
              <el-radio v-if="!!rowData.id" label="自动分配（成员不可见）">自动分配（成员不可见）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen('addCluePoolForm')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { approvalManagementApi, cluePoolManagementApi } from '../../service';
import { arrayQuery } from '@/utils/utils';

export default {
  data () {
    return {
      rules: {
        poolName: [
          { required: true, message: '请输入线索池名称', trigger: 'blur' }
        ],
        poolAdmin: [
          { required: true, message: '请选择管理员', trigger: 'change' }
        ],
        deptCode: [
          { required: true, message: '请选择部门', trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      formData: {
        distributeType: '手动领取（成员可见）',
        poolAdmin: []
      },
      poolAdminList: [],
      poolAdminLoading: false,
      deptList: [],
      deptLoading: false
    };
  },
  watch: {
    addPoolVisible (val) {
      if (val) {
        if (this.rowData.id) {
          this.$set(this.formData, 'poolName', this.rowData.poolName);
          // 线索管理员选项处理
          if (this.rowData.admins) {
            this.rowData.admins.forEach(item => {
              this.poolAdminList.push({
                customField: item.adminId + '-' + item.adminName,
                userId: item.adminId,
                userName: item.adminName
              });
              this.formData.poolAdmin.push(item.adminId + '-' + item.adminName);
            });
          }
          // 线索池所属部门选项处理
          this.$set(this.formData, 'deptCode', this.rowData.deptVO.deptCode);
          this.getDeptList(this.rowData.deptVO.deptName);
          this.$set(this.formData, 'distributeType', this.rowData.distributeType);
        }
        this.$nextTick(() => {
          this.$refs.addCluePoolForm.clearValidate();
        });
      } else {
        this.formData = {
          distributeType: '手动领取（成员可见）',
          poolAdmin: []
        };
        this.poolAdminList = [];
      }
      this.dialogVisible = val;
    }
  },
  props: {
    addPoolVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    submitHandlen (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            poolName: this.formData.poolName,
            distributeType: this.formData.distributeType
          };
          params.poolAdminList = this.formData.poolAdmin.map(item => {
            let adminData = item.split('-');
            return {
              userId: adminData[0],
              userName: adminData[1]
            };
          });
          params.dept = {
            deptCode: this.formData.deptCode,
            deptName: arrayQuery(this.formData.deptCode, this.deptList, 'deptCode').deptName
          };
          if (this.rowData.id) {
            params.poolId = this.rowData.poolId;
            params.id = this.rowData.id;
            this.$emit('editCluePool', params);
          } else {
            this.$emit('addCluePool', params);
          }
        }
      });
    },
    getPoolAdminList (query) {
      if (query !== '') {
        this.poolAdminLoading = true;
        approvalManagementApi.getApprovedList(query).then(res => {
          if (res.status === '200') {
            this.poolAdminList = res.data ? res.data.map(item => {
              item.customField = item.userId + '-' + item.userName;
              return item;
            }) : [];
          }
          this.poolAdminLoading = false;
        });
      } else {
        this.poolAdminList = [];
      }
    },
    getDeptList (applyKey) {
      if (!applyKey) {
        this.deptList = [];
        return;
      }
      applyKey = applyKey || 'all';
      let params = {
        type: 'APPLAY',
        key: applyKey
      };
      approvalManagementApi.getDeptList(params).then(res => {
        if (res.status === '200') {
          this.deptList = res.data;
        }
      });
    }
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
.addCluePoolDialog {
  ::v-deep.el-form {
    .danger{
      color: #F56C6C;
      &:before{
        content: '*';
        margin-right: 4px;
        opacity: 0;
      }
    }
    .el-form-item__content {
      > .el-select {
        margin-bottom: 10px;
      }

      > .el-select:last-child {
        margin-bottom: 0;
      }
      .special > .el-input{
        height: auto;
      }
    }
  }
}
</style>
